export enum OrganizationId {
  Diagnostic = '31e26eb2-2c58-43f6-af39-b8f9231c9a93',
  Surgical = 'bcf49107-9f9a-46e7-aeef-cc98db06ead7',
  Medical = '0e4626af-6947-3bfb-1c1e-4438f04ad89c',
}
